import { Zap, Search, FolderOpen, Lock } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "Capture in seconds",
    description: "Mobile-first. Open, type, done. AI generates the title so you don't have to.",
  },
  {
    icon: Search,
    title: "Search everything",
    description: "Every idea is instantly searchable. No scrolling through 200 notes to find that one thing.",
  },
  {
    icon: FolderOpen,
    title: "Organize when you're ready",
    description: "Archive the duds. Surface the winners. Make progress on the ones that matter.",
  },
  {
    icon: Lock,
    title: "Your ideas stay yours",
    description: "Secure, private, no training AI on your business concepts.",
  },
];

const SolutionSection = () => {
  return (
    <section className="section-padding bg-muted/30">
      <div className="section-container">
        <h2 className="text-sm font-semibold uppercase tracking-widest text-primary mb-4">
          The Solution
        </h2>
        
        <p className="text-lg text-muted-foreground mb-12 max-w-2xl">
          Founder Labs Ideas is an idea journal built for how entrepreneurs actually think:
        </p>
        
        <div className="grid gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="flex gap-4 md:gap-6 items-start p-6 rounded-xl bg-card shadow-sm border border-border/50 hover:shadow-md transition-shadow duration-300"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground text-lg mb-1">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <p className="mt-12 text-lg text-foreground font-medium">
          Simple as Apple Notes. Powerful enough to actually use.
        </p>
      </div>
    </section>
  );
};

export default SolutionSection;
